import React from "react";
import { motion } from "framer-motion";

const How = () => {
  const steps = [
    {
      id: "01",
      title: "Download",
      desc: "Open Play Store or App Store",
      active: true,
    },
    {
      id: "02",
      title: "Install App",
      desc: "The app will install automatically.",
      active: false,
    },
    {
      id: "03",
      title: "Ready to Use",
      desc: "Sign up or log in to start exploring!",
      active: false,
    },
  ];

  return (
    <section className="bg-bggraycolor font-avant py-24 px-6 overflow-hidden">
      <div className="container mx-auto max-w-6xl">
        {/* Header Section */}
        <div className="text-center mb-20">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-6xl font-bold text-zinc-900 mb-6 tracking-tight"
          >
            How to Install Our App
          </motion.h2>
          <p className="text-zinc-500 text-lg max-w-2xl mx-auto">
            Getting started is quick and easy! Follow these simple steps.
          </p>
        </div>

        {/* Timeline Container */}
        <div className="relative w-full">
          {/* Horizontal Line (Desktop only) */}
          {/* Isko top-6 par rakha hai taake ye 01, 02 ke darmiyan se guzre */}
          <div className="hidden lg:block absolute top-6 left-[10%] right-[10%] h-[1px] bg-zinc-300 z-0"></div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-8 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="flex flex-col items-center group">
                {/* Number Circle - Perfectly Aligned */}
                <motion.div
                  initial={{ scale: 0, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{
                    delay: index * 0.2,
                    type: "spring",
                    stiffness: 100,
                  }}
                  viewport={{ once: true }}
                  className={`w-12 h-12 flex items-center justify-center font-bold text-xl mb-12 bg-bggraycolor transition-colors duration-300
                    ${step.active ? "text-bgcolor" : "text-zinc-400"}`}
                >
                  {step.id}
                </motion.div>

                {/* Card - Smooth Float Animation */}
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.1, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{
                    y: -10,
                    boxShadow:
                      "shadow-[inset_0_2px_2px_rgba(255,255,255,0.8),_5px_5px_15px_rgba(255,255,255,1),5px_5px_10px_rgba(0,0,0,0.3)",
                  }}
                  className="bg-bggraycolor w-full px-0 rounded-[2.5rem] text-center border border-white
                             shadow-[inset_0_2px_2px_rgba(255,255,255,0.8),_5px_5px_15px_rgba(255,255,255,1),5px_5px_10px_rgba(0,0,0,0.3)]
            transition-all duration-500
                             min-h-[220px] flex flex-col justify-center"
                >
                  <h3 className="text-2xl font-bold text-zinc-800 mb-4 tracking-tight">
                    {step.title}
                  </h3>
                  <p className="text-zinc-500 text-sm md:text-base leading-relaxed">
                    {step.desc}
                  </p>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default How;
